import Api from './Api';

const Products = () => {
  return Api().get('/products');
};

const Product = (id) => {
  return Api().get(`/products/${id}`);
};

const AddProduct = (data) => {
  return Api().post('/products', data);
};

const RemoveProduct = (id) => {
  return Api().delete(`/products/${id}`);
};

const EditProduct = (id, data) => {
  return Api().put(`/products/${id}`, data);
};

export { Products, Product, AddProduct, RemoveProduct, EditProduct };
